import * as React from "react"
import { Component } from "react"
import { Image } from "semantic-ui-react"
import FormatingHelpIcon from "../../assets/images/formate-bulk-upload.svg"
import { withTranslation } from "react-i18next"

class BulkUploadFormatingHelp extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props
    return (
      <div className="hover-menu-wrapper">
        <div className="label-div">
          <span>{t("formatingHelp")}</span>
          <Image src={FormatingHelpIcon} className="vehicle-icons" />
        </div>
        <div className="tooltip-container">
          <div className="tooltip-box">
            <ul>
              <li>{t("formatingHelpTooltip1")}</li>
              <li>{t("formatingHelpTooltip2")}</li>
              <li>{t("formatingHelpTooltip4")}</li>
            </ul>
          </div>
          <div className="full-triangle"></div>
        </div>
      </div>
    )
  }
}

export default withTranslation("vehicle")(BulkUploadFormatingHelp)
